// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsIWR5tVdQ56IT34xvTOouojJlV3yQUkw",
  authDomain: "qroke-a6fed.firebaseapp.com",
  projectId: "qroke-a6fed",
  storageBucket: "qroke-a6fed.firebasestorage.app",
  messagingSenderId: "136121305771",
  appId: "1:136121305771:web:682226adc166e3e046c5ee",
  measurementId: "G-G4S8VFXV7V"
};

export default firebaseConfig;